import { LocalizedLabel } from "@hooks/LocalizationContext";
import React from "react";
export var ErrorMessage = function (_a) {
    var className = _a.className;
    return (React.createElement("div", { className: className },
        React.createElement(LocalizedLabel, { section: "BusinessCard", label: "MissingContactText" })));
};
